<template>
  <div style="padding: 10px;">
    <van-nav-bar title="轻客洗衣卡登记业务" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <div style="white-space: pre-wrap;text-align: center;font-size: 16pt;">
      正在进行卡绑定业务
    </div>
        <div v-if="pageType==10" style="text-align: left;">
        <div style="padding-top: 20px;">请输入您的卡号：</div>
        <div style="padding-top: 10px;"></div>
        <div class="fieldBox">
            <van-field v-model="cardNumber"  placeholder="请输入卡号"/>
        </div>
        <div style="padding-top: 40px;"></div>
        <van-button type="primary" color="#46C9BA" block @click="checkCard">下一步</van-button>
               <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </div>
    <div v-else style="text-align: left;">
      <van-field v-model="cardNumber" label="卡号" disabled="true" placeholder="请输入卡号"/>

      <van-field
        readonly
        label="卡类型"
        :value="cardType"
        placeholder="选择卡类型"
        disabled="true"
      />
      <van-field v-model="phone" type="tel" maxlength="11" label="手机号" placeholder="请输入手机号"/>
      <van-field
        v-model="verifyCode"
        type="digit"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
        maxlength="6"
      >
        <template #button>
          <van-button size="small" type="primary" color="#46C9BA" v-on:click="sendVerifyCode">发送验证码</van-button>
        </template>
      </van-field>

      <div style="padding-top: 35px;"></div>
      <van-button type="primary" color="#46C9BA" block v-on:click="verifyAccount">绑定</van-button>
      <div style="padding-top: 20px;"></div>
    </div>
      <div style="padding-top: 20px;"></div>

    <div class="hint">
      卡绑定流程：
      <div> 1、输入卡号后，核对卡号归属，填入手机号码和验证码完成绑定。</div>
      <div>2、绑定后遇卡遗失可办理补卡，未绑定则无法办理。</div>
    </div>
 
  </div>
</template>

<script>

  export default {
    data () {
      return {
        pageType:10,
        cardType: '轻客一卡通',
        cardNumber: '',
        phone: '',
        verifyCode: '',
        showPicker: false,
        columns: ['轻客一卡通'],
      }
    },
    methods: {

      //   后退
      onClickLeft () {
        this.$router.go(-1)
      },
      onConfirm (value) {
        this.cardType = value
        this.pageType = 20
        this.showPicker = false
      },
      checkCard(){
        let data = new FormData()
        data.append('cardNumber', this.cardNumber)
        this.$axios.post('/api/smartcard/get-cardtype-list-by-cardnumber',data).then(res => {
          if (res.data.success) {
            var rs = res.data.userObject
            if (rs.length ==1) {
              this.cardType = rs[0].cardType
              this.pageType = 20
            }else if(rs.length >1){
              this.columns = []
              rs.forEach((item,key) => {
                this.columns.push(item.cardType)
              });
              this.showPicker = true;
            }else{
                 this.$toast.fail('加载卡信息失败')
            }
    
          } else {
            this.$toast.fail('加载卡信息失败，原因：' + res.data.msg + '!')
          }
          //加载状态结束
            this.finished = true
        }).catch(error => {
          this.finished = true
          this.$toast.fail('加载卡信息失败!')
        })

      },
      onLoad: function () {
        console.log('onload...')

        this.$axios.post('/api/smartcard/get-cardtype-list').then(res => {
          if (res.data.success) {
            this.columns = res.data.userObject
          } else {
            this.$toast.fail('加载卡类型失败，原因：' + res.data.msg + '!')
          }
          //加载状态结束
          this.finished = true
        }).catch(error => {
          this.finished = true
          this.$toast.fail('加载卡类型失败!')
        })

      },
      sendVerifyCode () {

        if (this.cardType == null || this.cardType.length == 0) {
          this.$toast.fail('请选择卡类型!')
          return
        }

        if (this.cardNumber == null || this.cardNumber.length == 0) {
          this.$toast.fail('请输入正确的卡号!')
          return
        }

        if (this.phone == null || this.phone.length != 11) {
          this.$toast.fail('手机号格式不正确!')
          return
        }

        let data = new FormData()
        data.append('phone', this.phone)

        this.$axios.post('/api/smartcard/send-verifycode', data).then(res => {
          if (res.data.success) {
            this.$toast.success('验证码发送成功!')
          } else {
            this.$toast.fail('操作失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          this.$toast.fail('操作失败!')
        })

      },

      verifyAccount () {

        if (this.cardType == null || this.cardType.length == 0) {
          this.$toast.fail('请选择卡类型!')
          return
        }

        if (this.cardNumber == null || this.cardNumber.length == 0) {
          this.$toast.fail('请输入正确的卡号!')
          return
        }

        if (this.phone == null || this.phone.length != 11) {
          this.$toast.fail('手机号格式不正确!')
          return
        }

        if (this.verifyCode == null || this.verifyCode.length != 6) {
          this.$toast.fail('请输入正确的短信验证码!')
          return
        }

        let data = new FormData()
        data.append('cardType', this.cardType)
        data.append('cardNumber', this.cardNumber)
        data.append('phone', this.phone)
        data.append('verifyCode', this.verifyCode)

        this.$axios.post('/api/smartcard/verify-card-bind', data).then(res => {
          if (res.data.success) {
            this.$toast.success('卡绑定成功!')
          } else {
            this.$toast.fail('卡绑定失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          this.$toast.fail('操作失败!')
        })

      }
    }
  }

</script>
<style>
  .hint {
    /* white-space: pre-wrap; */
    text-align: left;
    font-size: 10pt;
    color: red;
  }
      .fieldBox{
      border-radius: 10px;
      padding: 4px;
      border: 1px solid #bbbbbb;
    }
</style>



// WEBPACK FOOTER //
// src/pages/topUpRecharge/binding.vue